export default __webpack_public_path__ + "static/media/HousePicture.07c5d3bb.jpg";